import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle4() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article4" headerImage="rodolfo.jpeg" reference="https://www.pexels.com/photo/photo-of-wind-turbines-lot-1292464/" photographer="Narcisa Acik" />
        <Footer />
    </div>
  )
}
